var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    fill: "#ED6759"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.7625 4.5L5.94375 3.31875C6.01875 3.24375 6.01875 3.13125 5.94375 3.05625C5.86875 2.98125 5.75625 2.98125 5.68125 3.05625L4.5 4.2375L3.31875 3.05625C3.24375 2.98125 3.13125 2.98125 3.05625 3.05625C2.98125 3.13125 2.98125 3.24375 3.05625 3.31875L4.2375 4.5L3.05625 5.68125C3.01875 5.71875 3 5.75625 3 5.8125C3 5.925 3.075 6 3.1875 6C3.24375 6 3.28125 5.98125 3.31875 5.94375L4.5 4.7625L5.68125 5.94375C5.71875 5.98125 5.75625 6 5.8125 6C5.86875 6 5.90625 5.98125 5.94375 5.94375C6.01875 5.86875 6.01875 5.75625 5.94375 5.68125L4.7625 4.5Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossSmall);
export default __webpack_public_path__ + "static/media/cross_small.99e2d179c1935c30434a8edd3196629b.svg";
export { ForwardRef as ReactComponent };